<template>
<v-card tile >
  <v-list v-if='withTitle' dark class='pa-0' >
    <v-list-tile >
      <v-list-tile-content>
        <v-list-tile-title v-text='title' />
        <v-list-tile-sub-title >
          Custom shared calendar
          <v-chip class='v-chip--x-small' >Read only</v-chip>
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action >
        <v-btn @click='get' :loading='req.loading' small icon >
          <v-icon >replay</v-icon>
        </v-btn>
      </v-list-tile-action>
    </v-list-tile>
  </v-list>
  <!-- @dayview:createevent='slotSelected'
  @dayview:multiselect='multiselect' -->
  <day-view class='ml-0' flat
    v-if='date && calendarId'
    :readOnly='true'
    :date='date'
    :with-fetch='false'
    :start-hour='settings.startHour'
    :end-hour='settings.endHour'
    :events='events' >
  </day-view>
</v-card>
</template>
<script>
import DayView from '@/components/calendar/DayView'
import moment from 'moment'

export default {
  name: 'SharedCalendarDayView',
  components: {DayView},
  props: {
    withTitle: { type: Boolean, default: false },
    calendarId: { required: true },
    touch: { type: Number, default: 0 },
    date: { type: String, required: true },
    title: { type: String, required: true },
    settings: {type: Object, required: false, default: () => { return {} }}
  },
  data () {
    return {
      req: {
        resource: 'ag.practitioner.calendars'
      }
    }
  },
  watch: {
    watchString: {
      immediate: true,
      handler () {
        this.get()
      }
    }
  },
  computed: {
    watchString () {
      return `${this.touch} ${this.date} ${this.calendarId}`
    },
    appointments () {
      return this.getObjectPath(this.req, 'result.appointments', [])
    },
    events () {
      return this.appointments.map((appointment) => {
        let dt = appointment.start_time.split('T')[0]
        let startMoment = moment(appointment.start_time)
        let endMoment = moment(appointment.end_time)
        appointment.dt = dt
        appointment.start = startMoment.format('HH:mm')
        appointment.end = endMoment.format('HH:mm')
        appointment.duration = moment.duration(
          endMoment.diff(startMoment)
        ).minutes()
        return appointment
      })
    }
  },
  methods: {
    get () {
      if (this.calendarId) {
        this.req.resourceId = this.calendarId
        this.req.params = {date: this.date}
        this.$request('get', this.req)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// SharedCalendarDayView.vue?b97d5e5c